import { render, staticRenderFns } from "./TransitionButton.vue?vue&type=template&id=11281740&"
import script from "./TransitionButton.vue?vue&type=script&lang=js&"
export * from "./TransitionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports